import Header from './components/Header';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import ReasonsSection from './components/ReasonsSection';
import StoreInfoSection from './components/StoreInfoSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen">
      <Header />
      <HeroSection />
      <ServicesSection />
      <ReasonsSection />
      <StoreInfoSection />
      <Footer />
    </main>
  );
}
